var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNlc2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#F28F01"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2099 7.71694L9.11812 5.57044C9.34537 5.07544 9.459 4.79419 9.459 4.7295C9.459 4.49719 9.306 4.32731 9.00056 4.21875H12.3463C11.934 4.40438 11.5672 4.86844 11.2466 5.6115L10.2099 7.71694ZM8.56969 11.0514L8.06063 12.0864H11.0627C12.4222 12.0864 13.3312 11.8316 13.7897 11.3214L12.1854 13.7812H3.98137C4.86731 13.6108 5.76112 12.5437 6.66225 10.5784C6.966 9.97425 7.24444 9.41625 7.49869 8.9055L8.56969 11.0514ZM2.8125 11.3906C3.47681 10.9963 5.90625 6.79387 5.90625 5.6115C5.90625 5.33306 5.73806 5.06981 5.40225 4.82231H8.0145L10.2831 9.27844L12.4836 4.82231H15.1875C14.0417 5.12381 11.7731 10.5294 11.7731 11.1583C11.7731 11.2821 11.7956 11.3597 11.8418 11.3906H9.45844L7.41881 7.30575L5.40225 11.3906H2.8125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNlc2);
export default __webpack_public_path__ + "static/media/nlc2.0119e331eaff0163c7dbad5cbc722412.svg";
export { ForwardRef as ReactComponent };